import Reveal from "@/components/base/Reveal";
import { reactions } from "@/mocks/home";
import SectionHeading from "@/pages/home/components/SectionHeading";

export default function ReactionsSection() {
  return (
    <section id="reactions" className="w-full border-b border-background-300 bg-background-50">
      <div className="mx-auto w-full max-w-[1180px] px-4 py-10 md:px-6 md:py-14">
        <SectionHeading
          index="肆"
          title="各方反应"
          desc="同一件事，现场、品牌、粉丝和行业各有说法。原文照录，不做删改。"
        />

        <div className="grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3">
          {reactions.map((item, i) => (
            <Reveal key={item.source} delay={i * 70} className={i === 0 ? "lg:col-span-2" : ""}>
              <figure
                className={`flex h-full flex-col rounded-lg border p-5 md:p-6 ${
                  item.highlight
                    ? "border-accent-200 bg-accent-50"
                    : "border-background-300 bg-background-100"
                }`}
              >
                <span className="flex h-6 w-6 items-center justify-center">
                  <i
                    className={`ri-double-quotes-l text-xl ${
                      item.highlight ? "text-accent-700" : "text-primary-400"
                    }`}
                  />
                </span>
                <blockquote className="mt-3 flex-1 text-sm leading-[1.9] text-foreground-800 md:text-[15px]">
                  {item.quote}
                </blockquote>
                <figcaption className="mt-5 flex items-center justify-between border-t border-background-200 pt-4">
                  <span className="font-heading text-sm font-bold text-foreground-950">
                    {item.source}
                  </span>
                  <span
                    className={`rounded-md px-2 py-0.5 text-[11px] font-medium ${
                      item.highlight
                        ? "bg-accent-100 text-accent-900"
                        : "bg-secondary-100 text-secondary-900"
                    }`}
                  >
                    {item.role}
                  </span>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}